import { t } from 'i18next';

import { Job } from '~hooks/useJob/models';

/**
 * Builds the Gantt row label for a truck on the order: `<TruckNumber> · <Vendor>`.
 *
 * Truck number comes from the job's equipment (external id preferred, then name).
 * Vendor resolution depends on how the job is assigned:
 * - Vendor-assigned jobs read `vendorJobAssignment.vendorAccount`. Internal
 *   (connected-company) vendors show the company's legal name; otherwise the
 *   account's own name.
 * - Driver-assigned jobs show the driver's company legal name.
 */
export function getTruckReplayRowLabel(job: Job) {
  const truckNumber =
    job.equipment?.externalId ?? job.equipment?.name ?? t('truck_replay.unknown_truck');

  const vendorAccount = job.vendorJobAssignment?.vendorAccount;
  if (vendorAccount) {
    return {
      truckNumber,
      vendor: vendorAccount.connectedCompany?.legalName ?? vendorAccount.name,
    };
  }

  return {
    truckNumber,
    vendor: job.driver?.company?.legalName ?? '',
  };
}
